import { render, staticRenderFns } from "./directInvest_SignUp.vue?vue&type=template&id=058fd288&scoped=true"
import script from "./directInvest_SignUp.vue?vue&type=script&lang=js"
export * from "./directInvest_SignUp.vue?vue&type=script&lang=js"
import style0 from "./directInvest_SignUp.vue?vue&type=style&index=0&id=058fd288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058fd288",
  null
  
)

export default component.exports